import { render, staticRenderFns } from "./non_gfm_markdown.vue.js?vue&type=template&id=32c56741&scoped=true&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./non_gfm_markdown.vue?vue&type=template&id=32c56741&scoped=true&vue3"
import script from "./non_gfm_markdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./non_gfm_markdown.vue?vue&type=script&lang=js&vue3"
export * from "./non_gfm_markdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./non_gfm_markdown.vue?vue&type=script&lang=js&vue3"
import style0 from "./non_gfm_markdown.vue.scss?vue&type=style&index=0&id=32c56741&prod&scoped=true&lang=scss&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./non_gfm_markdown.vue?vue&type=style&index=0&id=32c56741&prod&scoped=true&lang=scss&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c56741",
  null
  
)

export default component.exports